import React from 'react';
import { Divider } from '@mui/material';
import type { DividerBlock } from '../../../types/backend';

interface Props {
  block: DividerBlock;
}

// block is unused but kept for a uniform (block) => component contract.
const DividerBlockView: React.FC<Props> = () => (
  <Divider sx={{ my: 2 }} />
);

export default DividerBlockView;
